<template>
    <div class="col-6 col-sm-3 col-md-3 mb-3">
        <strong>
            <span>{{ title }}:</span>
        </strong>
      
        <div v-if="value != '' && value > 0">
            <span>{{ this.$n(value) }}</span>
            <slot></slot>
        </div>
  
        <div v-else>
            <span>{{$t('pds.details.not_specified')}}</span>
        </div>
    </div>
</template>
  
  <script>
    export default {
        name: "PDSDataEntry",
        props: {
        title: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: '-'
        },
    },
  }
  </script>
